<template>
            <v-text-field id="email-field" type="email" :label="`${$t('login.fields.labels.email')} *`" @input="$emit('input', $event)" :rules="rules"></v-text-field>
</template>

<script>
    export default {
        name: 'EmailField',
        computed: {
            rules() {
                return [
                    v => !!v || this.$t('login.fields.rules.required')
                ]
            }
        }
    };
</script>

<style scoped>

</style>